import { render } from "./InboundShipmentExport.vue?vue&type=template&id=e113d36c"
import script from "./InboundShipmentExport.vue?vue&type=script&lang=js"
export * from "./InboundShipmentExport.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__